import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import InputBox from 'presentation/components/InputBox';
import SubmitButton from 'presentation/components/icons/SubmitButton';
import { TypingState } from 'app/modules/session/constants';

import styles from 'presentation/components/styles/Composition.css';
let cx = classnames.bind(styles);

// Typing event is throttled to 1/5sec, stop typing event debounced every start typing call
// Stop typing timeout must be at least 500ms longer to allow time for next typing update
const START_TYPING_INTERVAL = 5000;
const STOP_TYPING_TIMEOUT = 5500;

class Composition extends React.Component {
  constructor(props) {
    super(props);

    const compositionPropTypes = {
      prompt: PropTypes.string.isRequired,
      onSubmit: PropTypes.func.isRequired,
      compositionDraft: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      onCustomerTypingStateUpdate: PropTypes.func.isRequired,
    };
    PropTypes.checkPropTypes(compositionPropTypes, props, 'prop', 'Composition');

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.input.focus();
  }

  componentWillMount() {
    this.handleActiveTyping = throttle(this.handleTypingStart, START_TYPING_INTERVAL, { trailing: false });
    this.handleTypingTimeout = debounce(this.handleTypingStop, STOP_TYPING_TIMEOUT);
  }

  handleInputChange(ev) {
    this.props.onChange(ev.target.value);
    this.handleActiveTyping();
  }

  handleKeyPress(ev) {
    let charCode = ev.which || ev.keyCode;

    if (charCode === 13 && !ev.shiftKey) {
      this.handleSubmit();
      ev.stopPropagation();
      ev.preventDefault();
      return false;
    }
  }

  handleSubmit() {
    // dont send unless there is at least one non-whitespace character
    if (!/\S+/.test(this.props.compositionDraft)) {
      return;
    }
    this.handleTypingStop();
    this.props.onSubmit(this.props.compositionDraft);
    this.input.focus();
  }

  handleTypingStart() {
    this.props.onCustomerTypingStateUpdate(TypingState.STARTED);
    this.handleTypingTimeout();
  }

  handleTypingStop() {
    this.props.onCustomerTypingStateUpdate(TypingState.STOPPED);
  }

  render() {
    // classname only applies when there there is content in the inputBox
    let submitClasses = cx({ chatSubmitArrow_customColors: /\S+/.test(this.props.compositionDraft) });
    let compositionInputBoxClasses = cx(styles.composition_inputBox, 'composition_inputBox');

    return (
      <div className={styles.composition}>
        <div className={styles.composition_wrapper}>
          <pre className={styles.composition_spacer}>
            {this.props.compositionDraft}
            <br />
          </pre>
          <InputBox
            aria-label="inputBox"
            role="form"
            className={compositionInputBoxClasses}
            prompt={this.props.prompt}
            onChange={this.handleInputChange}
            onKeyPress={this.handleKeyPress}
            value={this.props.compositionDraft}
            ref={input => (this.input = input)}
            data-aid="gladlyChatCompositionInput"
            data-gramm_editor="false"
          />
        </div>
        <SubmitButton
          aria-label="submitButton"
          role="button"
          className={submitClasses}
          onClick={this.handleSubmit}
          onKeyDown={this.handleKeyPress}
          data-aid="gladlyChatCompositionSubmit"
        />
      </div>
    );
  }
}

export default Composition;
